var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ]
    },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "background-color": "background",
            height: _vm.EQUIPMENT_TABS_HEIGHT
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tab", [_vm._v("\n      Inventaire P3\n    ")]),
          _vm._v(" "),
          _c("v-tab", [_vm._v("\n      Inventaire Technique\n    ")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "transparent-body",
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab-item",
            [
              _c("loader", { attrs: { "is-loading": _vm.P3Loading } }, [
                !_vm.P3Inventory.length
                  ? _c(
                      "div",
                      { staticClass: "background caption font-italic ma-2" },
                      [
                        _vm._v(
                          "\n          Pas de données liées à l'installation\n        "
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        style: `height:${_vm.height -
                          _vm.EQUIPMENT_TABS_HEIGHT}px; overflow-y: auto;`
                      },
                      [
                        _c("display-cards", {
                          staticClass: "mx-2",
                          attrs: { items: _vm.P3Inventory },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function({ item }) {
                                return [
                                  _c("p3-inventory-card", {
                                    key: item.line_number,
                                    attrs: { item: item }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c(
                "loader",
                { attrs: { "is-loading": _vm.techLoading } },
                [
                  !_vm.techInventoriesTree.length
                    ? _c(
                        "div",
                        { staticClass: "background caption font-italic ma-2" },
                        [
                          _vm._v(
                            "\n          Pas de données liées à l'installation\n        "
                          )
                        ]
                      )
                    : _vm._l(_vm.techInventoriesTree, function(inventory) {
                        return _c(
                          "v-card",
                          {
                            key: inventory.technical_inventory_code,
                            staticClass: "background ma-2",
                            attrs: { elevation: "0" }
                          },
                          [
                            _c("v-card-title", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(inventory.technical_inventory_code) +
                                  " -\n            " +
                                  _vm._s(inventory.technical_inventory_name) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-row",
                                  _vm._l(inventory.children, function(item) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: item.technical_inventory_code,
                                        attrs: { cols: "12", sm: "6" }
                                      },
                                      [
                                        _c("tech-inventory-card", {
                                          attrs: { item: item }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }